/*******************************************************************************
 * Copyright (c) 2024. dnote.ai
 *
 * @project DNOTE.AI-Frontend
 * @author dnote.ai
 * @copyright Dnote.ai All rights reserved
 ******************************************************************************/

export const CHURCH_MEMBER_MODEL = {

}

export const CHURCH_MEMBER_SUBSCRIPTION = {
    subscription    : null,
    amount          : null
}
export const COMMUNICATION_WAY = [
    {label : "Sms" , value: "SMS"},
    {label : "Mail" , value:"MAIL"},
    {label : "Telegram" , value:"TELEGRAM"},
    {label : "Whatsapp" , value:"WHATSAPP"}

]
export const CHURCH_EVENT = {
    title                   : null,
    place                   : null,
    expectedAttendees       : null,
    eventDate               : null,
    description             : null,
    remarks                 : null,
    attendees               : []
}
export const BAPTIZED_MODEL = {
    date       : null,
    baptist     : null,
}


